import { render, staticRenderFns } from "./GomokuBoard.vue?vue&type=template&id=0b3d5ea5&scoped=true"
import script from "./GomokuBoard.vue?vue&type=script&lang=js"
export * from "./GomokuBoard.vue?vue&type=script&lang=js"
import style0 from "./GomokuBoard.vue?vue&type=style&index=0&id=0b3d5ea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d5ea5",
  null
  
)

export default component.exports